import React, { useEffect, useState } from "react";
import {
  createAssessmentsAPIEndpoint,
  EndPoints as EndPointsAssessment,
} from "../../../services/AssessmentAPI";
import {
  Box,
  Button,
  Pagination,
  PaginationItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import HomeworkDetailsDialog from "../components/Homework/HomeworkDetailsDialog";
import AddHomeworkDialog from "../components/Homework/AddHomeworkDialog";
import AssessmentStatusToggle from "./../components/General/AssessmentStatusToggle";
import {
  createGeneralAPIEndpoint,
  EducationStageEndPoints,
} from "../../../services/General";
import { toUtcISOString } from "../../../context/AuthContext";
import { useNavigate } from "react-router-dom";

function Homework() {
  const [Homeworks, setHomeworks] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [totalCount, setTotalCount] = useState(0);
  const [search, setSearch] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedHomework, setSelectedHomework] = useState(null);
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [educationStages, setEducationStages] = useState([]);
  const navigate = useNavigate();
  const fetchHomeworks = (page, pageSize, search) => {
    createAssessmentsAPIEndpoint(EndPointsAssessment.searchAssessment)
      .fetch({ params: { type: 1, search, page: page + 1, pageSize } })
      .then((response) => {
        setHomeworks(response.data.items || []);
        setTotalCount(response.data.totalCount || 0);
      })
      .catch((error) => {
        console.error("Error fetching Homework data:", error);
        setHomeworks([]);
      });
  };

  const handleViewClick = (Homework) => {
    setSelectedHomework(Homework);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    fetchHomeworks(page, pageSize, search);
    setOpenDialog(false);
  };
  const handleResultsClick = (assessment) => {
    navigate(`/assessments/${assessment.id}/results`);
  };
  const handleHomeworkAdded = (data) => {
    try {
      const payload = {
        ...data,
        type: 1,
        durationMinutes: data.durationMinutes || 0,
        opensAtUtc: toUtcISOString(data.opensAtUtc),
        closesAtUtc: toUtcISOString(data.closesAtUtc),
      };
      createAssessmentsAPIEndpoint(EndPointsAssessment.createAssessment)
        .postWithToken(payload)
        .then((res) => {
          setHomeworks((prevHomeworks) => [...prevHomeworks, data]);
        })
        .catch((err) => console.log(err));
    } catch {}
    setOpenAddDialog(false);
    fetchHomeworks(page, pageSize, search);
  };
  useEffect(() => {
    createGeneralAPIEndpoint(EducationStageEndPoints.all)
      .fetch()
      .then((res) => {
        setEducationStages(res.data || []);
      })
      .catch((err) => {
        console.error("Failed to fetch education stages:", err);
      });
    fetchHomeworks(page, pageSize, search);
  }, [page, pageSize, search, openDialog]);

  return (
    <section className="dashboard-section">
      <div className="table-wrapper">
        <TableContainer
          component={Paper}
          sx={{ margin: "2rem auto" }}
          className="table-container"
        >
          <Box className="table-box">
            <TextField
              label="Search"
              variant="standard"
              size="large"
              value={search}
              onChange={(e) => {
                setPage(0);
                setSearch(e.target.value);
              }}
              className="search-field"
            />
            <Button
              variant="contained"
              className="btn-add-record"
              onClick={() => setOpenAddDialog(true)}
            >
              Add New Homework
            </Button>
          </Box>
          <div className="table-title">Homeworks Data</div>
          <Table className="table">
            <TableHead>
              <TableRow>
                <TableCell className="table-header">
                  <b>Title</b>
                </TableCell>
                <TableCell className="table-header">
                  <b>Center</b>
                </TableCell>
                <TableCell className="table-header">
                  <b>Status</b>
                </TableCell>
                <TableCell className="table-header">
                  <b>Actions</b>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.isArray(Homeworks) && Homeworks.length !== 0 ? (
                Homeworks.map((Homework) => (
                  <TableRow key={Homework.id} className="table-row">
                    <TableCell className="table-cell">
                      {Homework.assessmentTitle || "N/A"}
                    </TableCell>
                    <TableCell className="table-cell">
                      {Homework.centerName || "N/A"}
                    </TableCell>
                    <TableCell className={`table-cell status-cell ${Homework.status === 'Active' ? 'active' : 'inactive'}`}>
                      {Homework.status}
                    </TableCell>
                    <TableCell className="table-cell action-cell">
                      <Button
                        className="btn-view"
                        onClick={() => handleViewClick(Homework)}
                      >
                        View
                      </Button>
                      <Button
                        className="btn-results"
                        onClick={() => handleResultsClick(Homework)}
                      >
                        Results
                      </Button>
                      <AssessmentStatusToggle
                        assessment={Homework}
                        fetchAssessments={fetchHomeworks}
                        page={page}
                        pageSize={pageSize}
                        search={search}
                      />
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={6} className="table-cell">
                    No Homeworks found.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          <Pagination
            className="pagination"
            page={page + 1}
            count={Math.ceil(totalCount / pageSize)}
            onChange={(event, newPage) => setPage(newPage - 1)}
            renderItem={(item) => <PaginationItem component="div" {...item} />}
          />
          <HomeworkDetailsDialog
            open={openDialog}
            onClose={handleCloseDialog}
            selectedHomework={selectedHomework}
          />
          <AddHomeworkDialog
            open={openAddDialog}
            onClose={() => setOpenAddDialog(false)}
            onSubmit={handleHomeworkAdded}
            educationStages={educationStages}
          />
        </TableContainer>
      </div>
    </section>
  );
}

export default Homework;
